import { useLocalStorage } from '@vueuse/core'

/**
 * Generic, reusable user-preferences store backed by localStorage.
 *
 * State is persisted under `key` and automatically reloaded on the next visit. Because
 * `useLocalStorage` shares one reactive ref per key, every component using the same key stays
 * in sync — set a preference in one place (e.g. a settings popover) and another component
 * (e.g. a page) reads the new value reactively.
 *
 * `mergeDefaults` keeps stored preferences forward-compatible when new keys are added to the shape.
 */
export function useUserPreferences<T extends object>(key: string, defaults: T) {
  const preferences = useLocalStorage<T>(key, defaults, { mergeDefaults: true })

  function reset() {
    preferences.value = JSON.parse(JSON.stringify(defaults))
  }

  return {
    preferences,
    reset,
  }
}
